import dayjs, { Dayjs } from "dayjs";

import { MonthlyCashflowResult } from "@/api/generated";

/*
  過去履歴
 */
export const getFormatStartMonth = (result: MonthlyCashflowResult): string => {
  return result?.month ? dayjs(result?.month).format("YYYY/MM") : "-年/-月";
};

export const getFormatCost = (cost: number): string => {
  return cost ? `${cost.toLocaleString()}円` : "-円";
};

/** 未来の適用予定も含む最新履歴。開始月を併記する履歴一覧・履歴編集向け。 */
export const getLatestMonthlyCashflowResult = (
  results: MonthlyCashflowResult[],
  key: string
): MonthlyCashflowResult => {
  return results
    .filter((result) => result[key] !== undefined && result[key] !== null)
    .sort((a, b) => dayjs(b.month).valueOf() - dayjs(a.month).valueOf())[0];
};

export const getLatestMonthlyCashflowResultByCostType = (
  results: MonthlyCashflowResult[],
  costType: string
): MonthlyCashflowResult => {
  const getCostByType = (costType: string, data: any) => {
    switch (costType) {
      case "賃貸管理費":
        return data.management_cost;
      case "建物管理費":
        return data.building_management_cost;
      case "修繕積立金":
        return data.repair_fund_cost;
      case "通信費":
        return data.communication_cost;
      case "その他経費":
        return data.misc_cost;
      case "管理会社委託費":
        return data.management_company_commission;
      case "共用部水道光熱費":
        return data.shared_utility_expenses;
      case "固定資産税・都市計画税":
      case "固定資産税・都市計画税（年）":
        return data.property_tax;
      case "消耗品費":
        return data.supplies_cost;
      case "設備修繕、大規模修繕費用":
        return data.large_scale_repair_fund_cost;
      case "その他一過性の支出":
      case "その他":
        return data.misc_onetime_cost;
      default:
        return undefined;
    }
  };

  return results
    .filter((result) => {
      const cost = getCostByType(costType, result);
      return cost !== undefined && cost !== null;
    })
    .sort((a, b) => dayjs(b.month).valueOf() - dayjs(a.month).valueOf())[0];
};

/**
 * 対象月の時点で有効な入力値（月が対象月以前で、そのうち最も新しい入力）を返す。
 * 今月の適用値の表示用。履歴一覧・選択した履歴の編集には使わない。
 * nullは履歴の削除・未入力として除外し、0円の入力は有効値として扱う。
 */
export const getMonthlyCashflowResultEffectiveOn = (
  results: MonthlyCashflowResult[],
  key: string,
  targetMonth: Dayjs
): MonthlyCashflowResult | undefined => {
  const monthStart = targetMonth.startOf("month");
  return results
    .filter(
      (result) =>
        result[key] !== undefined &&
        result[key] !== null &&
        !!result.month &&
        dayjs(result.month).isValid() &&
        !dayjs(result.month).startOf("month").isAfter(monthStart)
    )
    .sort((a, b) => dayjs(b.month).valueOf() - dayjs(a.month).valueOf())[0];
};
